import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <Section background="white" id="pricing" data-id="element-133">
      <div className="max-w-md mx-auto bg-cream rounded-3xl overflow-hidden shadow-xl border border-peach/50" data-id="element-134">
        <div className="bg-terracotta p-6 text-center text-white" data-id="element-135">
          <h3 className="text-xl font-medium opacity-90 mb-2" data-id="element-136">
            Oferta Especial
          </h3>

          {/* Badge de descuento */}
          <div className="inline-block bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-3" data-id="element-137">
            68% OFF
          </div>

          {/* Precio original tachado */}
          <div className="text-2xl font-medium opacity-60 line-through mb-1" data-id="element-138">
            $19.99 <span className="text-base" data-id="element-139">USD</span>
          </div>

          {/* Precio de descuento destacado */}
          <div className="text-5xl font-bold font-serif text-green-400" data-id="element-140">
            $6.39 <span className="text-2xl font-normal opacity-90" data-id="element-141">USD</span>
          </div>

          <p className="mt-2 text-sm opacity-90" data-id="element-142">
            Pago único • Acceso de por vida
          </p>
        </div>

        <div className="p-8" data-id="element-143">
          <div className="text-center mb-8" data-id="element-144">
            <h2 className="text-2xl font-bold text-warm-dark mb-2" data-id="element-145">
              Sistema Anti-Antojos
            </h2>
            <p className="text-warm-gray" data-id="element-146">
              El método completo de 14 días para recuperar el control.
            </p>
          </div>

          <Button className="w-full text-lg py-4 mb-4" size="lg" withIcon onClick={() => window.location.href = 'https://brisavital.com/cart/42729068855344:1'} data-id="element-147">
            Descargar Ahora
          </Button>

          <div className="flex items-center justify-center text-sm text-warm-gray gap-2" data-id="element-148">
            <ShieldCheck className="w-4 h-4 text-terracotta" data-id="element-149" />
            <span data-id="element-150">Compra segura y garantizada</span>
          </div>

          <div className="mt-8 pt-8 border-t border-cream-dark text-center" data-id="element-151">
            <p className="text-sm text-warm-gray mb-4" data-id="element-152">
              Si estás lista para dejar de "empezar el lunes" y empezar con un
              sistema que aguante tu vida real.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}